import { ElementDetails } from "@/lib/types";
import { FieldSize } from "../ElementSettings/FieldSize";

export const details = {
  name: "Greeting",
  description: "Greet yourself when you open your dashboard",
  category: "Widget",
  grid: {},
  defaultProps: {
    name: "",
    fontSize: "30px",
    lineHeight: "36px",
  },
  fields: [
    {
      prop: "name",
      title: "Name",
      type: "input",
      config: {},
    },
    {
      prop: "fontSize",
      title: "Font Size",
      type: "custom",
      config: {
        render: props => (
          <FieldSize allowAuto={false} units={["px", "rem"]} {...props} />
        ),
      },
    },
    {
      prop: "lineHeight",
      title: "Line Height",
      type: "custom",
      config: {
        render: props => (
          <FieldSize allowAuto={false} units={["px", "rem"]} {...props} />
        ),
      },
    },
  ],
} as ElementDetails;
